let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lxHfr")).then(() => parcelRequire('cNXTd'));